export interface ApiResponse<T> {
    data: T;
    message?: string;
}

export interface ApiError {
    message: string;
    statusCode: number;
} 

export enum ProductAccessType {
    Free = 0,
    Paid = 1,
    Subscription = 2
}

export interface ProductStepDto {
    id: number;
    title: string;
    description: string;
    orderIndex: number;
    isCompleted: boolean;
}

export interface ScheduleDto {
    id: number;
    onlineClassId: number;
    date: string;
    startTime: string;
    endTime: string;
    timeZone: string;
}

export interface ProductDto {
    id: number;
    title: string;
    descriptionShort: string;
    imageUrl: string;
    createdDate: string;
    lastUpdated?: string;
    isFeatured: boolean;
    viewCount: number;
    averageRating: number;
    ratingCount: number;
    minimumAge?: number;
    maximumAge?: number;
    accessType: string;
    categoryId?: number;
    categoryName: string;
    instructorId?: number;
    instructorName: string;
    hasPricing: boolean;
    price: number;
    currency: string;
    productType: string;
    whatyourwilllearn?: string[];
    
    // OnlineClass specific properties
    startDate?: string;
    endDate?: string;
    maxStudents?: number;
    currentEnrollment?: number;
    meetingLink: string;
    relatedProjectId?: number;
    hasSchedule: boolean;
    schedule?: { $id: string; $values: ScheduleDto[] } | ScheduleDto[];
    
    // Project specific properties
    isTemplate: boolean;
    stepCount: number;
    
    steps: { $id: string; $values: ProductStepDto[] } | ProductStepDto[];
}

export interface OnlineClass {
    id: number;
    title: string;
    description: string;
    shortDescription: string;
    imageUrl: string;
    startDate: Date;
    endDate?: Date;
    price: number;
    currency: string;
    maxStudents?: number;
    currentEnrollment?: number;
    instructorName: string;
    meetingLink: string;
    isFeatured: boolean;
    averageRating: number;
    ratingCount: number;
    minimumAge?: number;
    maximumAge?: number;
    accessType: ProductAccessType;
    categoryName: string;
    hasSchedule: boolean;
    schedule: ScheduleDto[];
    viewCount: number;
    createdDate: Date;
    lastUpdated?: Date;
    whatyourwilllearn?: string[];
} 